import * as Cookies from 'js-cookie';
import * as AuthRepo from 'repositories/auth';

import {
  CLIENT_ACCESS_TOKEN_KEY,
  CLIENT_EXPIRATION_TOKEN_KEY,
  CLIENT_REFRESH_TOKEN_KEY,
  COOKIE_EXPIRED_DURATION_IN_DAYS,
  SCOPE_ALL,
  TOKEN_TYPE_BEARER
} from 'constants/auth';
import { Auth } from 'models/auth';

export function isAuthenticated() {
  return !!getAccessTokenFromCookies() && !!getRefreshTokenFromCookies();
}

export function initSession(username: string, password: string) {
  return AuthRepo.getTokens(username, password)
    .then((auth) => {
      saveTokens(auth);
      return auth;
    });
}

export function destroySession() {
  Cookies.remove(CLIENT_ACCESS_TOKEN_KEY);
  Cookies.remove(CLIENT_REFRESH_TOKEN_KEY);
  Cookies.remove(CLIENT_EXPIRATION_TOKEN_KEY);
}

export function getAccessToken() {
  return new Promise((resolve, reject) => {
    getSession()
      .then((auth) => {
        resolve(auth.accessToken);
      })
      .catch((error) => reject(error));
  });
}

export function getSession(): Promise<Auth> {
  return new Promise((resolve, reject) => {
    if (!isAuthenticated()) {
      reject(new Error('Not Authenticated'));
    }

    if (getExpirationTokenFromCookies() <= Date.now()) {
      const refreshToken = getRefreshTokenFromCookies();
      AuthRepo.refreshTokens(refreshToken)
        .then((auth) => {
          saveTokens(auth);
          resolve(auth);
        })
        .catch((error) => reject(error));
    } else {
      resolve(createSessionFromCookies());
    }
  });
}

function saveTokens(auth: Auth) {
  const cookieOptions = { expires: COOKIE_EXPIRED_DURATION_IN_DAYS };

  Cookies.set(CLIENT_ACCESS_TOKEN_KEY, auth.accessToken, cookieOptions);
  Cookies.set(CLIENT_REFRESH_TOKEN_KEY, auth.refreshToken, cookieOptions);
  Cookies.set(
    CLIENT_EXPIRATION_TOKEN_KEY,
    String(Date.now() + (auth.expiresIn * 1000)),
    cookieOptions
  );
}

function createSessionFromCookies(): Auth {
  return {
    accessToken: getAccessTokenFromCookies(),
    expiresIn: getExpirationTokenFromCookies(),
    refreshToken: getRefreshTokenFromCookies(),
    scope: SCOPE_ALL,
    tokenType: TOKEN_TYPE_BEARER
  };
}

function getAccessTokenFromCookies() {
  return Cookies.get(CLIENT_ACCESS_TOKEN_KEY) || '';
}

function getRefreshTokenFromCookies() {
  return Cookies.get(CLIENT_REFRESH_TOKEN_KEY) || '';
}

function getExpirationTokenFromCookies() {
  return Number(Cookies.get(CLIENT_EXPIRATION_TOKEN_KEY));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/auth.ts